import { render, staticRenderFns } from "./AccountList.vue?vue&type=template&id=8c2c66d8&scoped=true&"
import script from "./AccountList.vue?vue&type=script&lang=js&"
export * from "./AccountList.vue?vue&type=script&lang=js&"
import style0 from "./AccountList.vue?vue&type=style&index=0&id=8c2c66d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2c66d8",
  null
  
)

export default component.exports